module.exports = __webpack_public_path__ + "img/icon_1_22.22af294e.png";